<script setup lang="ts">
interface AppPromptProps {
  title: string;
  description: string;
}

interface AppPromptEmits {
  confirm: [];
  cancel: [];
}

const props = defineProps<AppPromptProps>();
const emit = defineEmits<AppPromptEmits>();
const model = defineModel<boolean>("open");

function handleConfirm() {
  emit("confirm");
  model.value = false;
}

function handleCancel() {
  emit("cancel");
  model.value = false;
}
</script>

<template>
  <AlertDialog v-model:open="model">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ props.title }}</AlertDialogTitle>
        <AlertDialogDescription>
          {{ props.description }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="secondary" @click="handleConfirm()">Confirmar </Button>
        <Button @click="handleCancel()">Cancelar</Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<style></style>
